const BUY_FORM_NAME = 'buy-form';
export const PRE_BUY_FORM_NAME = 'pre-buy-form';
export default BUY_FORM_NAME;
